"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var React = __importStar(require("react"));
function my_finance_report(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { fill: "none", className: "icon ".concat(className), height: "".concat(height), viewBox: "0 0 48 50", width: "".concat(width) },
        React.createElement("path", { d: "M46.902 58.396H1.044a.839.839 0 0 1-.84-.84V43.485a.84.84 0 0 1 .84-.84h9.738v-4.508a.84.84 0 0 1 .84-.839h11.25v-5.352a.839.839 0 0 1 .838-.84h10.11v-5.634a.84.84 0 0 1 .838-.84h12.244a.839.839 0 0 1 .84.84v32.086a.839.839 0 0 1-.84.839Zm-45.02-1.678h44.181V26.31H35.497v5.635a.84.84 0 0 1-.839.839H24.55v5.352a.839.839 0 0 1-.839.84H12.46v4.508a.84.84 0 0 1-.839.84H1.883v12.394Z", fill: "#FEFEFE" }),
        React.createElement("path", { d: "M4.315 42.348a2.823 2.823 0 0 1-2.224-4.55l5.358-7.371 1.637-13.461-1.311.578-1.666 2.924a2.457 2.457 0 0 1-4.315-2.35l2.281-4.387a2.866 2.866 0 0 1 1.083-1.144l4.97-2.943a3.826 3.826 0 0 1 3.382-.247l4.713 1.93c.688.28 1.279.758 1.698 1.371l1.64 2.395 3.322-.966a2.502 2.502 0 0 1 1.523 4.764l-4.5 1.567a2.874 2.874 0 0 1-2.835-.56l-.78-.688-.263 2.588a6.917 6.917 0 0 1 3.683 6.818l-.577 7.636a2.854 2.854 0 1 1-5.683-.504l.503-6.88a1.02 1.02 0 0 0-2.024-.243l-.434 3.32a3.166 3.166 0 0 1-.736 1.638l-6.282 7.769a2.854 2.854 0 0 1-2.163.996Zm5.782-27.585a.839.839 0 0 1 .834.94l-1.846 15.14a.834.834 0 0 1-.155.394l-5.502 7.567a1.157 1.157 0 0 0-.24.88 1.134 1.134 0 0 0 .447.763 1.151 1.151 0 0 0 1.558-.167l6.271-7.759.019-.022c.19-.218.31-.487.35-.773l.434-3.32a2.695 2.695 0 0 1 4.81-1.277c.41.536.607 1.206.55 1.879l-.503 6.88a1.175 1.175 0 1 0 2.34.22l.577-7.636a5.238 5.238 0 0 0-3.105-5.339l-.106-.043a.84.84 0 0 1-.532-.868l.488-4.812a.84.84 0 0 1 1.39-.544l2.005 1.77a1.193 1.193 0 0 0 1.175.232l4.5-1.567a.825.825 0 0 0-.503-1.568l-3.91 1.136a.84.84 0 0 1-.923-.332l-1.984-2.896a2.122 2.122 0 0 0-.949-.767l-4.713-1.93a2.134 2.134 0 0 0-1.89.139l-4.968 2.948a1.187 1.187 0 0 0-.449.475l-2.281 4.386a.78.78 0 0 0 1.368.746l1.803-3.165a.839.839 0 0 1 .39-.352l2.916-1.285a.838.838 0 0 1 .335-.074Z", fill: "#FEFEFE" }),
        React.createElement("path", { d: "M17.639 10.414A5.207 5.207 0 0 1 17.319.01a5.208 5.208 0 1 1 .32 10.405Zm-.217-8.726a3.53 3.53 0 1 0 3.742 3.302 3.503 3.503 0 0 0-3.742-3.302Z", fill: "#FEFEFE" })));
}
my_finance_report.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
my_finance_report.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = my_finance_report;
